import React from 'react';
import './StatsWidget.css';

function StatsWidget({ stats }) {
  return (
    <div className="stats-widget">
      <h3>📊 Platform Statistics</h3>
      <div className="stats-widget-grid">
        <div className="stat-mini">
          <div className="stat-mini-icon">🎁</div>
          <div className="stat-mini-content">
            <div className="stat-mini-value">{stats?.totalGiveaways || 0}</div>
            <div className="stat-mini-label">Active Giveaways</div>
          </div>
        </div>
        <div className="stat-mini">
          <div className="stat-mini-icon">👥</div>
          <div className="stat-mini-content">
            <div className="stat-mini-value">{stats?.totalParticipants || 0}</div>
            <div className="stat-mini-label">Participants</div>
          </div>
        </div>
        <div className="stat-mini">
          <div className="stat-mini-icon">💰</div>
          <div className="stat-mini-content">
            <div className="stat-mini-value">${stats?.totalPrizes || 0}</div>
            <div className="stat-mini-label">Total Prizes</div>
          </div>
        </div>
        <div className="stat-mini">
          <div className="stat-mini-icon">⏰</div>
          <div className="stat-mini-content">
            <div className="stat-mini-value">24/7</div>
            <div className="stat-mini-label">Support</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsWidget;

